import { ModelEntityType } from '@upright/common/model/input/types';
import { GenericEmptyState } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/empty-states/generic-empty-state';
import { usePaiLensContext } from '@upright/ui/common/upright/core/impact-lenses/pais/common/use-pai-lens-context';
import { EmptyStateAggregates } from '@upright/ui/common/upright/core/impact-lenses/pais/empty-state/empty-state-aggregates';

export function PaiLensEmptyState() {
  const context = usePaiLensContext();
  if (!context) {
    return <></>;
  }

  const entityType = context.data.entity?.type;
  if (entityType && entityType !== ModelEntityType.COMPANY) {
    return <EmptyStateAggregates />;
  }
  return <GenericEmptyState dataTitle="EU SFDR Principal Adverse Impacts data" />;
}
